import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyMigrationModalMigrateAcademy.vue?vue&type=template&id=52f571aa"
import script from "./MoleculeEditionBillingAcademyMigrationModalMigrateAcademy.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyMigrationModalMigrateAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports